var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',{attrs:{"fluid":true}},[_c('page-header',{attrs:{"title":"Descuentos"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","to":"/descuentos/crear"}},[_c('v-icon',{attrs:{"name":"plus","width":"16"}}),_vm._v(" Crear descuento ")],1)],1),_c('tabla',{attrs:{"descuentos":_vm.descuentos},on:{"eliminar":_vm.eliminar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }